import { SRCheatingFlowOpenedEventHandler } from './SRCheatingFlowOpenedEvent';
import { SimpleRegistrationMainPageExThemeClickedEventHandler } from './SRCheatingMainPageExThemeClickedEvent';
import { SimpleRegistrationMainPageExThemeOpenedEventHandler } from './SRCheatingMainPageExThemeOpenedEvent';
import { SimpleRegistrationMainPageExpertsClickedEventHandler } from './SRCheatingMainPageExpertsClickedEvent';
import { SRCheatingMainPageExpertsOpenedEventHandler } from './SRCheatingMainPageExpertsOpenedEvent';
import { SRCheatingMainPageGenderClickedEventHandler } from './SRCheatingMainPageGenderClickedEvent';
import { SRMainPageGenderOpenedEventHandler } from './SRCheatingMainPageGenderOpenedEvent';

export * from './SRCheatingFlowOpenedEvent';
export * from './SRCheatingMainPageExThemeClickedEvent';
export * from './SRCheatingMainPageExThemeOpenedEvent';
export * from './SRCheatingMainPageExpertsClickedEvent';
export * from './SRCheatingMainPageExpertsOpenedEvent';
export * from './SRCheatingMainPageGenderClickedEvent';
export * from './SRCheatingMainPageGenderOpenedEvent';

export const srCheatingEventHandlers = [
  SRCheatingFlowOpenedEventHandler,
  SRMainPageGenderOpenedEventHandler,
  SRCheatingMainPageExpertsOpenedEventHandler,
  SimpleRegistrationMainPageExThemeOpenedEventHandler,
  SRCheatingMainPageGenderClickedEventHandler,
  SimpleRegistrationMainPageExpertsClickedEventHandler,
  SimpleRegistrationMainPageExThemeClickedEventHandler,
];
